import React from "react";
import { useSelector } from "react-redux";

import { PartnerCenterSeller } from "../../models/ticketing";
import { getPartnerCenterSellers } from "../../redux/selectors/partnerCenterSelectors";
import { sellerHasGdkSwRole } from "../../server/partnerCenter/helpers/gdkMiddlewareRequestHelpers";
import { GdkMiddlewareDropdown } from "./GdkMiddlewareDropdown";

export type SellerDropdownProps = {
  currentSeller: PartnerCenterSeller | undefined;
  setCurrentSeller: (seller: PartnerCenterSeller) => void;
};

export const SellerDropdown = ({ currentSeller, setCurrentSeller }: SellerDropdownProps) => {
  const sellers = useSelector(getPartnerCenterSellers)?.filter(seller =>
    sellerHasGdkSwRole(seller)
  );

  const handleSellerChange = (id: string) => {
    const selectedSeller = sellers.find(seller => seller.id === id);
    if (selectedSeller) {
      setCurrentSeller(selectedSeller);
    }
  };

  if (!sellers || sellers.length === 0) {
    return null;
  }

  return (
    <GdkMiddlewareDropdown
      currentValue={currentSeller?.id || ""}
      onChange={handleSellerChange}
      options={sellers.map(seller => ({ id: seller.id, label: seller.name }))}
    />
  );
};
